import React, { Component } from "react";

const Location = ({ width, height, fill, ...rest }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 12 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.66683 5.99904C7.66683 5.07819 6.92067 4.33203 6.0005 4.33203C5.07965 4.33203 4.3335 5.07819 4.3335 5.99904C4.3335 6.91921 5.07965 7.66536 6.0005 7.66536C6.92067 7.66536 7.66683 6.91921 7.66683 5.99904Z"
        stroke={fill}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.99967 13C5.20069 13 1 9.59892 1 6.04219C1 3.25776 3.23807 1 5.99967 1C8.76128 1 11 3.25776 11 6.04219C11 9.59892 6.79866 13 5.99967 13Z"
        stroke={fill}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

Location.defaultProps = {
  width: "12",
  height: "14",
  fill: "#000",
};

export default Location;
